import { createContext } from 'react'
import { DeviceHardwareContextType } from '@/types/IDeviceHardware'
export const DeviceHardwareContext = createContext<
  DeviceHardwareContextType | undefined
>(undefined)
